<template>
  <nav
    class="flex flex-col justify-center fixed top-0 left-0 bottom-0 transition-all duration-300 opacity-100"
  >
    <div
      class="transition-all duration-300 w-14 bg-slate-500 bg-opacity-70 shadow rounded-r"
    >
      <a
        v-for="social in socials"
        :key="social.url"
        :href="social.url"
        :title="social.name"
        target="_blank"
        class="group"
      >
        <NuxtImg
          :alt="social.name"
          height="56px"
          width="56px"
          class="px-3 max-w-none hover:w-20 transition-all duration-300 py-2 group-first:pt-4 group-last:pb-4"
          :src="social.icon.url"
        />
      </a>
    </div>
  </nav>
</template>

<script setup lang="ts">

const socials = [
  {
    url: "https://www.codecentric.de",
    name: "codecentric AG",
    icon: {
      url: "images/codecentric.png",
    },
  },
  {
    name: "GitHub",
    url: "https://github.com/dominikfladung",
    icon: {
      url: "images/github.png",
    },
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/dominik-f-6072a8164/",
    icon: {
      url: "images/linkedin.png",
    },
  },
  {   
    name: "Mail",
    url: "mailto:contact@teruslab.de",
    icon: {
      url: "images/mail.svg",
    },
  },
];
</script>

